import { useFreeGiftInteraction } from '@/components/blocks/FreeGiftV2/context/FreeGiftInteractionContext';
import { DrawerContent } from '@/components/blocks/FreeGiftV2/parts/DrawerContent';
import { DrawerContentMultiPromos } from '@/components/blocks/FreeGiftV2/parts/DrawerContentMultiPromos';
import { DrawerFooter } from '@/components/blocks/FreeGiftV2/parts/DrawerFooter';
import { PromotionDrawerSx } from '@/components/blocks/FreeGiftV2/styles/freeGift';
import DynamicIcon from '@/components/icons/DynamicIcon';
import { useLocalization } from '@/data/Localization';
import { useMobileApp } from '@/data/state/useMobileApp';
import CloseIcon from '@mui/icons-material/Close';
import { Box, SwipeableDrawer, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { MATERIAL_SYMBOL_ICONS } from 'shared/custom/constants/commonConstants';

// Swipe-to-open is disabled; the drawer is only opened through the footer button.
const noop = () => undefined;

export const PromotionDrawer = () => {
	const { openDrawer, handleCloseDrawer, showPromotionOptions } = useFreeGiftInteraction();

	const theme = useTheme();
	const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
	const { FreeProduct } = useLocalization('FreeGift');
	const { isMobileApp } = useMobileApp();

	return (
		<SwipeableDrawer
			open={openDrawer}
			onClose={handleCloseDrawer}
			onOpen={noop}
			anchor={isDesktop ? 'right' : 'bottom'}
			sx={isMobileApp ? PromotionDrawerSx.drawerPaperMobile : PromotionDrawerSx.drawerPaper}
			disableSwipeToOpen
			disableEnforceFocus
			ModalProps={{ keepMounted: true }}
		>
			<Box sx={PromotionDrawerSx.header}>
				<Box
					alignItems="center"
					gap="5px"
					display="flex"
					justifyContent="center"
					sx={PromotionDrawerSx.title}
				>
					<DynamicIcon
						name={MATERIAL_SYMBOL_ICONS.featuredSeasonalAndGifts}
						color={theme.palette.primary.main}
					/>
					<Typography variant="subtitle2" component="h3" color="grey.500">
						{FreeProduct.t()}
					</Typography>
				</Box>
				<CloseIcon sx={PromotionDrawerSx.closeButton} onClick={handleCloseDrawer} />
			</Box>
			<Box sx={PromotionDrawerSx.container}>
				{showPromotionOptions ? (
					<DrawerContentMultiPromos />
				) : (
					<>
						<Box sx={PromotionDrawerSx.contentContainer}>
							<DrawerContent />
						</Box>
						<DrawerFooter />
					</>
				)}
			</Box>
		</SwipeableDrawer>
	);
};
